import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './CustomerServicePage.scss';

export const CustomerServicePage: FC = (): ReactElement => (
    <Page className="customer-service-page">
        <ConnectedPageHelmet appRoute={AppRoute.customerService} />
        <ConnectedBlockRenderer appRoute={AppRoute.customerService} />
    </Page>
);
